const getTabUrlGetFeedback = () => {
  return 'get-feedback/home?withStatus';
};

export { getTabUrlGetFeedback };
